import { Control } from "slotworks/smart-ui/controls/control";
import ClearAutoplayButtonControl from "./clear-autoplay-button-control";

export default class CloseAutoplayButtonControl extends ClearAutoplayButtonControl implements Control {

    protected clearAutoplay() {
        super.clearAutoplay();

        this.smartUIGroup.hide();
    }
}
